import React from 'react';
import { GurmukhiWatermark } from './ui/Ornaments';
import { Logo } from './ui/Logo';
export const Footer = () => {
  return <footer className="bg-navy py-12 relative overflow-hidden" data-id="element-101">
      <GurmukhiWatermark text="ਖਾਲਸਾ" className="text-gold -bottom-10 right-10 opacity-[0.02]" data-id="element-102" />
      <div className="max-w-7xl mx-auto px-6 relative z-10" data-id="element-103">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-104">
          <div className="flex items-center gap-3 group cursor-pointer" data-id="element-105">
            <Logo height={56} className="group-hover:scale-[1.03] transition-transform duration-300" data-id="element-106" />
          </div>

          <div className="text-center md:text-right" data-id="element-107">
            <p className="font-sans text-xs text-parchment/50 mb-1" data-id="element-108">
              An initiative by The Sikh Initiative.
            </p>
            <p className="font-sans text-xs text-parchment/30" data-id="element-109">
              &copy; {new Date().getFullYear()} All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>;
};